export const VALID_SERVICE_TYPE = [
  'Customer Reimbursement',
  'Product Buyout',
  'Servicer Adjustment',
  'Overpaid Adjustment',
  'Parts Order',
  'Product Replacement',
  'Deductible',
  'Claim Fee',
];

export const VIRTUAL_CARD_STATUS_LIST = [
  {
    statusName: 'Active',
    statusCode: 'A',
  },
  {
    statusName: 'Cancelled',
    statusCode: 'C',
  },
  {
    statusName: 'On Hold',
    statusCode: 'H',
  },
  {
    statusName: 'Stolen',
    statusCode: 'S',
  },
  {
    statusName: 'Lost',
    statusCode: 'L',
  },
];

export const POST_DISPACTH_VALIDATE = {
  
  whenOnPointServiceOrderNumber:['request', 'serviceCompletionDate', 'solution', 'onPointServiceOrderNumber','jobNumberServiceProvider'],
  whenContractNumber: ['brand', 'contractNumber', 'serialNumber', 'modelNumber', 'request', 'solution', 'serviceCallDate', 'serviceCompletionDate', 'jobNumberServiceProvider'],
  default:['jobNumberServiceProvider','serviceProviderReferenceNumber','customerName','customerAddress','customerCity','customerStateCode','customerZipCode','customerPhone','customerEmail','modelNumber','serialNumber','request','solution','purchaseDate','serviceCallDate','serviceCompletionDate','brand','product'],
  provider:{
    samsung:"SAMSUNG"
  }
};

